import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { theme } from '_constants/theme';
import {
  selectCredentialsByCategory,
  selectUpdating as selectCredentialsUpdating,
  selectError,
} from '_store/credentials/selector';
import { setCredentials } from '_store/credentials/slice';
import { selectCustomerId } from '_store/user/selector';

import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';
import ChangeUsernameForm from 'components/composed/forms/ChangeUsernameForm';

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spaces.small}px;
`;

const StyledBody = styled.div``;

const ChangeUsernameView = () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const credentials = useSelector(selectCredentialsByCategory(CATEGORY_CODES.accounting));
  const credentialsUpdating = useSelector(selectCredentialsUpdating);
  const error = useSelector(selectError);

  const handleSubmit = useCallback(
    (values) => {
      if (values) {
        const { username } = values;

        if (credentials) {
          dispatch(setCredentials({ customerId, ...credentials, username }));
        }
      }
    },
    [customerId, credentials]
  );

  return (
    <Card>
      <StyledHeader>
        <Text size={theme.fontSizes.medium} weight={600}>
          Change Username
        </Text>
      </StyledHeader>
      <StyledBody>
        <ChangeUsernameForm
          error={error}
          loading={credentialsUpdating}
          defaultValues={{ username: credentials?.username }}
          onSubmit={handleSubmit}
        />
      </StyledBody>
    </Card>
  );
};

export default ChangeUsernameView;
